import { render, staticRenderFns } from "./MemberPhoto.vue?vue&type=template&id=73146c0a&scoped=true&lang=html&"
import script from "./MemberPhoto.vue?vue&type=script&lang=js&"
export * from "./MemberPhoto.vue?vue&type=script&lang=js&"
import style0 from "./MemberPhoto.vue?vue&type=style&index=0&id=73146c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73146c0a",
  null
  
)

export default component.exports